import React from 'react';
import FloatingPanel from './FloatingPanel';
import UserMentionInfoCard from './UserMentionInfoCard';

/**
 * UserMentionPopover
 *
 * Displays user information in a popover when clicking on a user mention.
 * Shows avatar, name, email, position, and availability status.
 *
 * @param {Object} props - Component props
 * @param {boolean} props.open - Whether the popover is open
 * @param {HTMLElement} props.anchorEl - Anchor element for the popover
 * @param {Function} props.onClose - Callback to close the popover
 * @param {{left: number, top: number}|null} [props.anchorPosition] - Optional absolute screen position for caret-based anchoring
 * @param {Object} props.userData - User data object (id, name, email, position, headshot, isAvailable)
 * @param {number} [props.nodePos] - Optional: Position of mention node in document (for advanced features)
 * @param {Object} [props.view] - Optional: ProseMirror editor view (for advanced features)
 */
export default function UserMentionPopover({open, anchorEl, anchorPosition, onClose, userData, nodePos: _nodePos, view: _view}) {
    if (!userData) {
        return null;
    }

    return (
        <FloatingPanel
            open={open}
            anchorEl={anchorEl}
            anchorPosition={anchorPosition}
            onClose={onClose}
            width={320}
            sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                boxShadow: 3,
                p: 2,
                minWidth: 280,
                maxWidth: 360,
            }}
        >
            <UserMentionInfoCard userData={userData} onMessageOpened={onClose}/>
        </FloatingPanel>
    );
}

